import { languageOptions } from './translations/fallback.js';

const DEFAULT_LANGUAGE_CODE = 'en';
const SYSTEM_LANGUAGE_OPTIONS = languageOptions;

export function getSystemLanguageOptions() {
  return SYSTEM_LANGUAGE_OPTIONS.map((option) => ({ ...option }));
}

export function getDefaultLanguageSettings() {
  return {
    availableLanguages: [DEFAULT_LANGUAGE_CODE],
    defaultLanguage: DEFAULT_LANGUAGE_CODE,
  };
}

export function normalizeLanguageSettings(rawSettings = {}) {
  const supportedCodes = new Set(SYSTEM_LANGUAGE_OPTIONS.map(({ code }) => code));
  const requestedCodes = Array.isArray(rawSettings?.availableLanguages) ? rawSettings.availableLanguages : [];
  const availableLanguages = [...new Set(requestedCodes.filter((code) => supportedCodes.has(code)))];
  const resolvedAvailableLanguages = availableLanguages.length > 0 ? availableLanguages : [DEFAULT_LANGUAGE_CODE];
  const defaultLanguage = resolvedAvailableLanguages.includes(rawSettings?.defaultLanguage)
    ? rawSettings.defaultLanguage
    : DEFAULT_LANGUAGE_CODE;

  return {
    availableLanguages: resolvedAvailableLanguages,
    defaultLanguage,
  };
}

export function getEventLanguageSettings(opts = {}) {
  return normalizeLanguageSettings(opts?.languageSettings);
}

export function getLanguageSwitcherModel(languageCodes = [], currentLanguage = DEFAULT_LANGUAGE_CODE) {
  const allowedCodes = new Set(Array.isArray(languageCodes) ? languageCodes : []);
  const languages = SYSTEM_LANGUAGE_OPTIONS.filter(({ code }) => allowedCodes.has(code)).map((language) => ({
    ...language,
  }));
  const selectedLanguage = languages.find(({ code }) => code === currentLanguage) || languages[0] || null;

  return {
    languages,
    selectedLanguage,
    isVisible: languages.length > 1,
  };
}
